module.exports = __webpack_public_path__ + "img/seller_scheduled postings.1dd08ea0.svg";